<aura-edit-wrapper
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  (saved)="phoneNumberSaved.emit($event)"
  [showDivider]="true"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing() && isAllowedToEdit()) {
    <aura-contact-infos-phone-form
      [dto]="currentMobileNumber()"
      [showOptionalFields]="['phoneNumber', 'website']"
      [requiredFields]="['mobileNumber', 'email']"
      [allReadonly]="!editWrapper.isEditing()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <aura-contact-infos-phone-display [currentMobileNumber]="currentMobileNumber()" />
  }
</aura-edit-wrapper>
